module.exports = __webpack_public_path__ + "src/img/up.1ca8c81e.svg";